import React from "react";
import { useTranslation } from "react-i18next";
import { Grid, Typography } from "@mui/material";
import MyContext from "../../../contexts/MyContext";
import { lngs } from "../../../Constant";
import { TicketForm1 } from "../ticket-forms/TicketForm1";

export const Slide1 = (props) => {
  const { t, i18n } = useTranslation();

  return (
    <MyContext.Consumer>
      {(context) => (
        <div hidden={context.activeSlide !== 0}>
          <TicketForm1 {...props} />
          <Grid container justifyContent="center" spacing={2}>
            {Object.keys(lngs).map((lng) => (
              <Grid item key={lng}>
                <Typography
                  lang={lng}
                  className="selector"
                  variant="overline"
                  display="block"
                  component="button"
                  gutterBottom
                  onClick={() => {
                    i18n.changeLanguage(lng);
                    document.documentElement.lang = lng;
                  }}
                  style={{ fontWeight: i18n.language === lng ? "bold" : "normal" }}
                >
                  {lngs[lng].nativeName}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </div>
      )}
    </MyContext.Consumer>
  );
};
